export enum ASYNC_UILS {

    // 获取专病、渠道模版数据
    TOPIC_VIEW = '/content-service/topic/view',
    TOPIC_PREVIEW = '/content-service/topic/preview',

    // 获取item
    TOPIC_ITEMLIST = '/content-service/topic/itemlist',
    TOPIC_PREVIEW_ITEMLIST = '/content-service/topic/previewitemlist',

    // 获取阅读数量
    TOPIC_VP = '/content-service/topic/pv',

    // 获取分享信息
    TOPIC_SHARE = '/wx-user/auth/authorization',

    // 获取我的票数
    TOPIC_MY_VOTE = '/content-service/topic/myvote',
    TOPIC_UPDATE_VOTE = '/content-service/topic/vote',
}

